<template>
  <div id="App">
    <Header v-if="this.$store.state.curUserName==''" />
    <div v-else-if="this.$store.state.curUserName=='admin'">
        <HeaderAdm  />
    </div>
    <div v-else>
        <HeaderLgd  />
    </div>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>

import Header from './components/Header.vue'
import HeaderLgd from './components/HeaderLgd.vue'
import HeaderAdm from './components/HeaderAdm.vue'

//if(!navigator.cookieEnabled) this.$showErr("Enable cookies please");

export default {
  name: 'App',
  data: function() {
    return {
      title: '',
    }
  },

  metaInfo() {
        return {
            title: `${this.title}`,
            meta: [
                { vmid: 'description', name: 'description', content:  this.metaDesc},
            ],
        }
    },

  components: {
      Header,
      HeaderLgd,
      HeaderAdm
  },
  beforeMount() {
      this.descMeta();
  },
  methods: {

    descMeta() {
        if(this.$i18n.locale === 'ru') {
            this.title = 'Путешествия, экскурсии и туры';
            this.metaDesc = 'Подробные описания путешествий, экскурсий и экскурсионных туров всего мира';
        }
        else {
            this.title = 'Travel, excursions and tours'
            this.metaDesc = 'Detailed descriptions of travel, excursions and sightseeing tours around the world';
        }
    }

  }
}
</script>

<style>
#app {
}

@font-face {
  font-family: "Noto";
  src: local("NotoSerif-Regular"),   url(./fonts/NotoSerif-Regular.ttf) format("truetype");
  font-display: swap;
}
/*
@font-face {
  font-family: "Pacifico";
  src: local("Pacifico-Regular"),   url(./fonts/Pacifico-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Roboto";
  src: local("Roboto-Light"),   url(./fonts/Roboto-Light.ttf) format("truetype");
}
@font-face {
  font-family: "NotoItalic";
  src: local("NotoSerif-BoldItalic"),   url(./fonts/NotoSerif-BoldItalic.ttf) format("truetype");
}
*/
</style>

